var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjibouti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 13.0435C10.9565 13.0435 3.52174 3.51305 3.51471 3.51473C5.68624 1.34316 8.68629 0 12 0C18.6274 0 24 5.37262 24 12L10.9565 13.0435Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 12C10.9565 12 3.52174 20.487 3.51471 20.4853C5.68624 22.6568 8.68629 24 12 24C18.6274 24 24 18.6274 24 12H10.9565Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51469C-1.17157 8.20097 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51469Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8567 8.86955L5.63365 11.2609H8.14831L6.11403 12.739L6.89094 15.1305L4.8567 13.6524L2.82237 15.1305L3.59947 12.739L1.56519 11.2609H4.07965L4.8567 8.86955Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjibouti);
export default __webpack_public_path__ + "static/media/djibouti.426b07d1d7964fb2dc425ae25f8bf625.svg";
export { ForwardRef as ReactComponent };